import {FC} from 'react'
import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {checkIsActive, KTIcon} from '../../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
  refresh?:boolean
  disabled?:boolean
}

const MenuItem: FC<Props> = ({to, title, icon, fontIcon, hasArrow = false, hasBullet = false, refresh=false, disabled=false}) => {
  const {pathname, search} = useLocation()
  const handleRefresh = (e)=>{
    e.preventDefault();
    window.location.href=to
  }

  return (
    <div className={clsx('menu-item me-lg-1')}>
      <Link
        className={clsx('menu-link py-3', {
          'active menu-here': checkIsActive(pathname, to, search),
          'menu-disable':disabled
        })}
        to={to}
        onClick={refresh ? handleRefresh : undefined}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        <span className='menu-title'>{title}</span>

        {hasArrow && <span className='menu-arrow'></span>}
      </Link>
    </div>
  )
}

export {MenuItem}
